﻿$.fn.dxCtrlConfigEnvoiResume = function custom_dxCtrlConfigEnvoiResume(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlconfigenvoiresume dx-ctrl");
        this.createInstance(new cdxCtrlConfigEnvoiResume(this, option));
    }
    return this;
}

window.cdxCtrlConfigEnvoiResume = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.css("height", ((container.innerHeight() == 0) ? "" : container.innerHeight() + 'px'))
        container.empty();

        table = option.bddCtrl.getObjet(option.data).mGetTable()

        var $Table = $("<table style='width:100%'>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='white-space:nowrap;padding:15px 0 5px 0;font-size:160%;;font-weight:bold;' colspan='2' class='dx-theme-accent-as-text-color'>Résumé de votre envoi</td>").appendTo($Tr)

        if (table.nom != "com_email_envoi" ||
            (table.nom == "com_email_envoi" && (option.lstDestComNettoye.length > parametre.nbre_destinataire_email_cc_cci_max || option.data.tracking == "1"))) {
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;'>Taille message</td>").appendTo($Tr)
            var $TdTailleMsg = $("<td style='white-space:nowrap;width:1px;font-size:300%;font-family:Barlow Condensed;text-align:right;'/>").appendTo($Tr)
            switch (table.nom) {
                case "com_email_envoi":
                    $TdTailleMsg.html((option.data.heberger_image == "1") ? option.data.taille_octet_ss_image.sizeFile(2) : option.data.taille_octet.sizeFile(2))
                    break;
                case "com_sms_envoi":
                    var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
                    $TdTailleMsg.html(sendSms.mGetNbCaractereMessage(option.data.tracking == "1") + " car./" + sendSms.mGetNbCredit1MessageFrance(option.data.tracking == "1") + " sms")
                    break;
                default: break;
            }

            var nbCredit = 0
            nbTotalCredit = 0
            //nbre credit message
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;'>Nbre crédit utilisé<br/>pour l'ensemble des destinataires</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:1px;font-size:300%;font-family:Barlow Condensed;text-align:right;'/>").appendTo($Tr)
            switch (table.nom) {
                case "com_email_envoi":
                    nbCredit = Math.ceil(option.data.taille_octet / 1024 / 256)
                    $Td.html(Math.ceil(option.data.taille_octet / 1024 / 256) + " crédit" + ((nbCredit > 1) ? "s" : ""))
                    nbTotalCredit = nbCredit * option.lstDestComNettoye.length
                    break;
                case "com_sms_envoi":
                    var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
                    option.lstDestComNettoye.forEach(function (comDest) {
                        comDest.nb_credit_par_message = sendSms.mGetNbCredit1Message(comDest.tel_code_pays, option.data.tracking == "1")
                    })
                    var lstNb = option.bddCtrl.getObjet(option.data).objetMetier.mGetRepartCreditParCodePays(option.lstDestComNettoye)
                    $Td.css("font-size", "100%")
                    var $TableDetailCredit = $("<table/>").appendTo($Td)
                    var $Tr = $("<tr style='line-height:0.8;text-align:center;vertical-align:bottom;font-size:90%;'/>").appendTo($TableDetailCredit)
                    var $TdPays = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Pays</td>").appendTo($Tr)
                    var $TdUnitaire = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Nb crédit<br/>unitaire</td>").appendTo($Tr)
                    var $TdNbComDest = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Nb<br/>destinataires</td>").appendTo($Tr)
                    var $TdTotal = $("<td style='padding:0 5px;opacity:0.3;'>Total</td>").appendTo($Tr)
                    lstNb.forEach(function (nb) {
                        var $Tr = $("<tr/>").appendTo($TableDetailCredit)
                        var indicatif = parametre.lstIndicatifTel.filter(function (o) { return o.code == nb.code_pays })[0]
                        var $TdPays = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;'><table><tr><td><img src='https://flagcdn.com/w20/" + nb.code_pays.toLowerCase() + ".png' style='padding-right:5px;padding-top:5px;'/></td><td>" + indicatif.name + "</td></tr></td>").appendTo($Tr)
                        var $TdUnitaire = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";text-align:center;padding:0 5px;'>" + nb.nb_credit + "</td>").appendTo($Tr)
                        var $TdNbComDest = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";text-align:center;padding:0 5px;'>" + nb.lstComDest.length + "</td>").appendTo($Tr)
                        var $TdTotal = $("<td style='padding:0 5px;'>" + (nb.nb_credit * nb.lstComDest.length) + "</td>").appendTo($Tr)
                        nbTotalCredit += (nb.nb_credit * nb.lstComDest.length)
                    })
                    var $TableTot = $("<table/>").appendTo($Td)
                    var $TrTot = $("<tr/>").appendTo($TableTot)
                    var $TdTot = $("<td style='width:100%;'/>").appendTo($TrTot)
                    var $TdTot = $("<td style='width:1px;white-space:nowrap;font-size:140%;'>Total crédits SMS: " + nbTotalCredit + "</td>").appendTo($TrTot)
                    var $TdTot = $("<td style='width:1px;padding-left:5px;'></td>").appendTo($TrTot)
                    $("<div/>").appendTo($TdTot).dxCtrlButton({
                        icon: 'fas fa-hand-holding-dollar',
                        txtTooltip: "Détails des prix SMS par pays",
                        onClick: function (e) {
                            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                width: 250,
                                target: e.component.element(),
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "15px")
                                    var sendSms = new cSendSms(option.bddCtrl)
                                    sendSms.mGetDivTarifSmsParPays(contentElement)
                                }
                            }).dxCtrlTooltip("instance")
                            tt.show()
                        }
                    })
                    break;
                default: break;
            }

            //nbre crédit total
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;'>Nbre total de crédit<br/>pour votre envoi (" + option.lstDestComNettoye.length + " destinataires)</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:1px;font-size:300%;font-family:Barlow Condensed;text-align:right;font-weight:bold;'>" + nbTotalCredit + " crédits</td>").appendTo($Tr)
            nbCreditDispo = 0
            idDisplayPlanCpteClient = 0
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td colspan='2' style='text-align:right;'></td>").appendTo($Tr)
            switch (table.nom) {
                case "com_email_envoi":
                    nbCreditDispo = option.bddCtrl.objCptCli.objetMetier.mGetNbEmailDispo()
                    idDisplayPlanCpteClient = 4
                    break;
                case "com_sms_envoi":
                    nbCreditDispo = option.bddCtrl.objCptCli.objetMetier.mGetNbSmsDispo()
                    idDisplayPlanCpteClient = 3
                    break;
                default: break;
            }
            $Td.html("Vous disposez de <b>" + nbCreditDispo + " crédits</b> pour votre envoi.")
            if (nbTotalCredit > nbCreditDispo) {
                $Td.css("color", "red")
                $("<div style='text-align:right;'>Vous ne disposez pas<br/>de suffisament de crédits<br/>pour votre envoi.</div>").appendTo($Td)
                var $Div = $("<div style='text-align:right;'></div>").appendTo($Td)
                var $A = $("<a href='javascript:void(0)'>Acheter des crédits</a>").appendTo($Div)
                $A.on("click", function () {
                    $("<div/>").appendTo("body").dxCtrlAchatPopup({
                        bddCtrl: option.bddCtrl,
                        typeProduit: ((table.nom == "com_email_envoi") ? "credit_email" : "credit_sms"),
                        nb: ((table.nom == "com_email_envoi") ? 1000 : 5),
                        onPaiement: function () {
                            jaugeDemarrage.mShow()
                            option.bddCtrl.mReloadTable("credit_sms", function () { jaugeDemarrage.mHide() })
                        }
                    })
                    //$("<div/>").appendTo("body").dxCtrlOffrePopup({
                    //    bddCtrl: option.bddCtrl,
                    //    idSelectedOnglet: ((table.nom == "com_email_envoi") ? 2 : 3)
                    //})
                })
            } else {
                $Td.css("color", "darkgreen")
            }
        } else {
            nbTotalCredit = 0
            switch (table.nom) {
                case "com_email_envoi":
                    $("<div style='padding-top:5px;'>Votre message comporte moins de " + parametre.nbre_destinataire_email_cc_cci_max + " destinataires et vous ne demandez pas de tracking.<br/>Aucun crédit nécessaire.</div>").appendTo(container)
                    break;
                case "com_sms_envoi":
                    break;
            }
        }

        container.css("height", "")
    }

    this.element = function () { return container }

    mConstruit();
}